import { BaseController } from '~client/controller/base-controller';
import { EventCarouselListResponse } from '~client/model/event-carousel-list-response';

export class EventUserController extends BaseController {
  public getCarouselListEvents(): Promise<EventCarouselListResponse> {
    return this.get('/event/public/carouselList');
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/controller/event-user-controller.ts